import { Component, HostBinding, Injector, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { isNullOrUndefined } from 'util';

type InputType = 'text' | 'password' | 'tel' | 'email' | 'date';

@Component({
    selector: 'jhi-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputComponent,
            multi: true
        }
    ]
})
export class InputComponent extends BaseControlValueAccessor implements OnInit {
    @Input()
    label: string;

    @Input()
    hintLabel: string;

    @Input()
    readonly: boolean;

    @HostBinding('class.hidden')
    @Input()
    hidden: boolean;

    @Input()
    placeholder = '';

    @Input()
    autocomplete: string;

    @Input()
    ariaDescribedBy: string;

    @Input()
    id: string;

    type: InputType;

    value: any;

    isPassword: boolean;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.hidden = isNullOrUndefined(this.hidden) ? false : this.hidden;
        this.isPassword = this.type === 'password';
    }

    @Input('type')
    set inputType(type: InputType) {
        this.type = type;
    }

    modelValueChanged(value: any): void {
        this.value = value;
    }

    toggle($event: any) {
        this.type = this.type === 'password' ? 'text' : 'password';
        $event.preventDefault();
    }

    hasValue(): boolean {
        return super.hasValue() || this.placeholder !== '';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/input/input.component.ts